module.exports = __webpack_public_path__ + "media/property_transaction_process/ssp_photo_0-3b089160.webp";